<template>
  <v-col>
    <v-card>
      <v-card-title>
        <router-link
          v-if="can_add()"
          :to="{ name: 'mentor_diary_add', user_id: user_id_local }"
        >
          <v-btn fab class="mt-n4" color="blue">
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
        </router-link>

        <p class="pl-6">{{ $tc("diaries.mentor", 2) }}</p>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('common.search')"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="downloadPdf()">
          {{ $t("user.download_pdf") }}
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="mentor_diaries"
        :loading="loading"
        item-key="id"
        class="elevation-1"
        :footer-props="footer"
        :loading-text="$t('common.loading')"
        :no-results-text="$t('common.no_results')"
        :options.sync="options"
        :server-items-length="$store.state.mentor_diary.totalCount"
        dense
        show-expand
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td class="pt-5" :colspan="headers.length">
            <div>
              <span class="font-weight-bold">{{ $t("diaries.comment") }}:</span>
              <p class="pre-formatted">{{ item.comment | capitalize }}</p>
            </div>
            <div>
              <span class="font-weight-bold"
                >{{ $t("diaries.followup") }}:</span
              >
              <p class="pre-formatted">{{ item.followup | capitalize }}</p>
            </div>
          </td>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_results") }}
        </template>

        <template #item.followup="{ item }">
          {{ item.followup | truncate(10) }}
        </template>
        <template #item.author="{ item }">
          <User :user="item.author" />
        </template>
        <template #item.comment="{ item }">
          {{ item.comment | truncate(10) }}
        </template>
        <template #item.date="{ item }">
          {{ item.date | date }}
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex">
            <router-link
              :to="{
                name: 'diary_mentor_form_edit',
                params: { diary_id: item.id, user_id: user_id_local },
              }"
            >
              <v-img src="/icons/crayon.png" width="30" class="mr-2" />
            </router-link>
            <v-img
              src="/icons/delete.png"
              max-width="30"
              class="mr-2"
              @click.prevent="remove('mentor_diary', item)"
            />
          </div>
        </template>
      </v-data-table> </v-card
  ></v-col>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import User from "@/components/card/User"
import Vue from "vue"
import { API_URL } from "@/utils/config"
import JwtService from "@/utils/jwt.service"
import { saveAs } from "file-saver"
import { filenameFrom } from "@/utils/download"

const { mapActions } = createNamespacedHelpers("mentor_diary")

export default {
  name: "MentorTable",
  components: { User },
  mixins: [TableMixin],
  data() {
    return {
      items: [],
    }
  },
  mounted() {
    console.log(this.current_user)
    if (this.user_id_local === undefined) {
      this.user_id_local = this.current_user.id
    }
  },
  computed: {
    mentor_diaries() {
      return this.$store.state.mentor_diary.data
    },
    current_user() {
      return this.$store.state.user.profile
    },

    headers() {
      return [
        {
          value: "date",
          text: this.$tc("common.date", 1),
          align: " text-no-wrap",
        },
        {
          value: "author",
          text: this.$tc("common.author", 1),
          width: "24%",
          align: " text-no-wrap",
        },
        {
          value: "comment",
          text: this.$t("diaries.comment"),
          width: "24%",
        },
        {
          value: "followup",
          text: this.$t("diaries.followup"),
          width: "24%",
        },
        {
          value: "actions",
          align: "right",
          width: "4%",
        },
      ]
    },
  },

  methods: {
    ...mapActions([FETCH]),
    async downloadPdf() {
      Vue.axios({
        url: API_URL + "users/" + this.user_id_local + "/mentor/pdf",
        responseType: "blob",
        method: "GET",
        params: {},
        headers: {
          Authorization: "Bearer " + JwtService.getToken(),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }).then((response) => {
        saveAs(response.data, filenameFrom(response, "journal-mentor.pdf"))
      })
    },
    can_add() {
      return ["MENTOR"].includes(this.current_user.role)
    },
  },
}
</script>
